export default function($) {
  var speed = 90; // ms
  var headerHeight = $('header').height();

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('nav-trigger-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).addClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  $('.js-nav-items').css('top', headerHeight);

  $(window).resize(function() {
    var headerHeight = $('header').height();
    $('.js-nav-items').css('top', headerHeight);
  });

  // Filter services form display

  $('.js-edit-search').on('click', function() {
    $('.js-filter-services-form').slideToggle();
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
